var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('Header'):_vm._e(),_c('div',{staticClass:"bodyWrapper"},[_c('router-view')],1),(this.$route.name !== 'home')?_c('reports'):_vm._e(),(
      this.$route.name !== 'home')?_c('vendorPortal'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }